// extracted by mini-css-extract-plugin
export var errorsContainer = "_u1-1";
export var link = "_u1-0";